import api from 'api';

export const updateDynamicData = api('POST /api/tracker/dynamic-data');
